

import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import icon from "../Vis 4/icon.png";
import { hover } from "@testing-library/user-event/dist/hover";

function Cards1() {
  const options = {
    chart: {
      type: "column",
      height: 80, // Restrict height
      spacing: [0, 0, 0, 0],
      backgroundColor: "transparent",
    },
    title: { text: null },
    xAxis: { visible: false },
    yAxis: { visible: false },
    legend: { enabled: false },
    credits: { enabled: false },
    exporting: { enabled: false },
    tooltip: { enabled: true },
    series: [
      {
        data: [10, 3, 2, 4, 8, 4],
        color: "#20486C",
      },
    ],
  };
  const pieOptions = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 100,
      width: 100,
    },
    title: {
      text: null,
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    plotOptions: {
      pie: {
        states: {
          hover: {
            enabled: false,
          },
          inactive: {
            opacity: 1,
          },
          halo: {
            opacity: 1,
          },
          select: {
            enabled: false,
            halo: {
              opacity: 1,
            },
          },
        },
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: false,
      },
    },
    exporting: { enabled: false },
    credits: { enabled: false },
    series: [
      {
        name: "Share",
        colorByPoint: true,
        data: [
          { name: "Used", y: 75, color: "#20486C" },
          { name: "Remaining", y: 25, color: "lightgrey" },
        ],
      },
    ],
  };
  const optionsLine = {
    chart: {
      type: "line",
      height: 60,
      width: 150,
      backgroundColor: "transparent",
      margin: [5, 5, 5, 5],
    },
    title: {
      text: null,
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
        lineWidth: 2,
        enableMouseTracking: false,
      },
    },
    exporting: { enabled: false },
    series: [
      {
        data: [2, 3, 2.5, 4, 3.8],
        color: "#20486C",
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <div style={{ height: "250px", marginBottom: "20px" }}>
      <div className="row mb-4">
        <div className="col-md-4">
          <div
            className="card bg-light text-center"
            style={
              {
                // border: "none",
                // boxShadow:
                //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              }
            }
          >
            <div
              className="card-body"
              style={{
                padding: "20px",
                textAlign: "left",
                backgroundColor: "white",
                borderRadius: "7px",
                // border: "none",
              }}
            >
              <h5
                style={{
                  fontSize: "16px",
                  fontFamily: "'Roboto Flex', serif",
                  color: "#3B3A3A",
                }}
              >
                Overall Data Completeness
              </h5>
              <h4 style={{ fontSize: "22px" }}>93.61%</h4>
              <p>
                <span style={{ color: "#20486C", fontWeight: "700" }}>
                  {" "}
                  Network A
                </span>{" "}
                has the most data completeness with an index of <b>97.19%</b>.
              </p>
              <HighchartsReact
                highcharts={Highcharts}
                options={options}
                containerProps={{ style: { width: "100%" } }}
              />
            </div>
          </div>
        </div>
        <div
          className="col-md-4 d-flex flex-column justify-content-around m0"
          style={{ gap: "10px" }}
        >
          <div
            className="card text-center"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: "70%",
              padding: "10px 20px",
              backgroundColor: "#F4FAFF ",
              border: "none",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
              gap: "10px",
            }}
          >
            <div>
              <img src={icon}></img>
            </div>
            <div
              className="card-body"
              style={{
                padding: "10px",
                backgroundColor: "#F4FAFF",
                border: "none",
                borderRadius: "7px",
                textAlign: "left",
              }}
            >
              <h5 style={{ fontSize: "16px", color: "#20486C" }}>
                MRF Record Count
              </h5>
              <p className="card-text display-11">
                <b style={{ color: "#20486C" }}>11,809M</b>
              </p>
            </div>
            <div>
              {" "}
              <HighchartsReact highcharts={Highcharts} options={pieOptions} />
            </div>
          </div>

          <a
            className="card bg-light text-center"
            href="/Diverging-Bar3"
            style={{
              height: "30%",
              textDecoration: "none",
            }}
          >
            <div
              className="card-body"
              style={{
                padding: "10px",
                background: "#12273B",
                border: "none",
                borderRadius: "7px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {" "}
                <small
                  className="d-block"
                  style={{ textAlign: "left", color: "white" }}
                >
                  Saved Network Categories Title
                </small>
                {/* <img src="../Vector.png"></img> */}
                <b style={{ color: "white" }}>&#10095;</b>
              </div>

              <div className="d-flex flex-wrap gap-2 mt-2">
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  BCBS
                </span>
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  Category III
                </span>
              </div>
            </div>
          </a>
        </div>
        <div
          className="col-md-4 d-flex flex-column justify-content-around m0"
          style={{ gap: "10px" }}
        >
          <div
            className="card text-center"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              height: "70%",
              padding: "10px 20px",
              backgroundColor: "#F4FAFF ",
              border: "none",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
              gap: "10px",
            }}
          >
            <div>
              <img src={icon}></img>
            </div>
            <div
              className="card-body"
              style={{
                padding: "10px",
                backgroundColor: "#F4FAFF",
                border: "none",
                borderRadius: "7px",
                textAlign: "left",
              }}
            >
              <h5 style={{ fontSize: "16px", color: "#20486C" }}>
                MRF Record Count
              </h5>
              <p className="card-text display-11">
                <b style={{ color: "#20486C" }}>11,809M</b>
              </p>
            </div>
            <div>
              <HighchartsReact highcharts={Highcharts} options={optionsLine} />
            </div>
          </div>
          <div
            className="card bg-light text-center"
            style={{
              height: "30%",
            }}
          >
            <div
              className="card-body"
              style={{
                padding: "10px",
                background: "#12273B",
                border: "none",
                borderRadius: "7px",
              }}
            >
              {/* <h5 style={{ fontSize: "16px" }}>MRF Record Count</h5>
              <p className="card-text display-11">11,809M</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <small
                  className="d-block"
                  style={{ textAlign: "left", color: "white" }}
                >
                  Saved Query Title
                </small>
                {/* <img src="../Vector.png"></img> */}
                <b style={{ color: "white" }}>&#10095;</b>
              </div>

              <div className="d-flex flex-wrap gap-2 mt-2">
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  BCBS
                </span>
                <span
                  className="badge  text-dark"
                  style={{ backgroundColor: "#F4FAFF" }}
                >
                  Category III
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cards1;
